import { useQueryClient } from "@tanstack/react-query";
import { Skeleton, Typography } from "antd";
import type { ReactNode } from "react";
import { useIntl } from "react-intl";
import { useParams } from "react-router-dom";
import Page from "~Common/Page";
import { LogoUploadModal } from "~Features/Organizations/components/LogoUploadModal/LogoUploadModal.tsx";
import { useFetchOrganization } from "~entities/api";
import { ImageBaseTypes } from "~enums/imageBaseTypes.ts";
import { ImageTypes } from "~enums/imageTypes.ts";

type Props = {
  children: ReactNode;
};

const ManageOrganizationsWrapper = ({ children }: Props) => {
  const { formatMessage } = useIntl();
  const { data, isLoading } = useFetchOrganization();
  const queryQlient = useQueryClient();

  const { sport, organizationId } = useParams();

  const titleText = `${formatMessage({
    id: "manage",
    defaultMessage: "Manage",
  })} - ${data?.nameLocal}`;

  const tabTitle = formatMessage(
    { id: "pageTitles.organization.manageOrganization" },
    { organizationName: data?.nameLocal },
  );

  if (isLoading) {
    return <Skeleton />;
  }

  return (
    <Page
      tabTitle={tabTitle}
      title={
        <div style={{ display: "flex", alignItems: "center", marginBottom: 15, marginTop: 10, gap: 5 }}>
          <LogoUploadModal
            uploadUrl={`/v1/${sport}/o/${organizationId}/images/for/${ImageBaseTypes.Organization}/${ImageTypes.Logo}`}
            refetch={() => {
              queryQlient.invalidateQueries({ queryKey: ["organization", sport, organizationId] });
            }}
            dataId={data?.organizationId}
            images={data?.images || []}
            imageBaseType={ImageBaseTypes.Organization}
            imageType={ImageTypes.Logo}
          />
          <Typography style={{ marginBottom: 0, fontSize: 30 }}>{titleText}</Typography>
        </div>
      }
    >
      {children}
    </Page>
  );
};

export default ManageOrganizationsWrapper;
